import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutGrid, PlusSquare, LogOut, Barcode, Users, Settings2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const baseNav = [
  { to: "/", icon: LayoutGrid, label: "Products", testid: "nav-products" },
  { to: "/new", icon: PlusSquare, label: "New Label", testid: "nav-new-label" },
  { to: "/settings", icon: Settings2, label: "Settings", testid: "nav-settings" },
];

const adminNav = [
  { to: "/admin/users", icon: Users, label: "Users", testid: "nav-users" },
];

export const AppShell = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin";
  const navItems = isAdmin ? [...baseNav, ...adminNav] : baseNav;

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex">
      {/* Sidebar */}
      <aside
        className="app-sidebar fixed inset-y-0 left-0 w-60 bg-zinc-950 text-zinc-300 flex flex-col z-20"
        data-testid="app-sidebar"
      >
        <div className="px-5 py-5 border-b border-zinc-800/60 flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-md bg-red-900/90 flex items-center justify-center">
            <Barcode size={18} className="text-white" />
          </div>
          <div>
            <div className="text-[15px] font-semibold text-white tracking-tight leading-none">
              Custom Barcode
            </div>
            <div className="text-[11px] text-zinc-500 mt-0.5">Generator</div>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-0.5">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 rounded-md text-[13px] font-medium transition-colors ${
                  isActive
                    ? "bg-zinc-800/80 text-white"
                    : "text-zinc-400 hover:text-white hover:bg-zinc-800/40"
                }`
              }
            >
              <item.icon size={16} strokeWidth={2} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="px-3 py-3 border-t border-zinc-800/60">
          <div className="px-2 py-2 text-[11px] text-zinc-500 truncate">
            {user?.email}
          </div>
          <button
            data-testid="logout-btn"
            onClick={handleLogout}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-[13px] text-zinc-400 hover:text-white hover:bg-zinc-800/40 transition-colors"
          >
            <LogOut size={15} />
            <span>Sign out</span>
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="app-main flex-1 ml-60 min-h-screen">{children}</main>
    </div>
  );
};

export default AppShell;
